export const COMPONENT_ORIGIN_KEY = 'component_origin'
